/* eslint-disable no-console */
import { useCallback, useMemo } from 'react'
import { useRouter } from 'next/router'
import { getEnv } from '../../config'

type UseAppBridgeReturn = {
  isInApp: boolean
  sendMessageToHost: (type: string, payload?: Record<string, any>) => void
}

const BRIDGE_PREFIX = 'moises'

export const useAppBridge = (): UseAppBridgeReturn => {
  const { query, isReady } = useRouter()

  const debug: boolean = getEnv() !== 'production'

  const isInApp = useMemo(
    () => (!isReady ? false : 'mobile' in query),
    [query, isReady]
  )

  const sendMessageToHost = useCallback<
    UseAppBridgeReturn['sendMessageToHost']
  >(
    (type, payload = {}) => {
      if (typeof window === 'undefined') return

      const message: Record<string, any> = {
        type: `${BRIDGE_PREFIX}:${type}`
      }

      if (Object.keys(payload).length > 0) {
        message.payload = payload
      }

      if (debug) {
        console.log('[bridge] starting to send message')
        console.table(message)
      }

      if (window.parent && window.parent !== window) {
        if (debug) {
          console.log('[bridge] sending message to parent window')
        }

        window.parent.postMessage(JSON.stringify(message), '*')
      } else {
        console.log('No parent window found to send message to.')
      }
    },
    [debug]
  )

  return {
    isInApp,
    sendMessageToHost
  }
}
